var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subject-list"},_vm._l((_vm.chunkedSubjects),function(chunk,i){return _c('div',{key:i,staticClass:"subject-list-line"},_vm._l((chunk),function([subject, color],i){return _c('div',{key:i,class:`subject-list-skill subject-list-${color}`},[_vm._v(" "+_vm._s(subject))])}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }